import { render, staticRenderFns } from "./instForm.vue?vue&type=template&id=585f8e73&scoped=true"
import script from "./instForm.vue?vue&type=script&lang=js"
export * from "./instForm.vue?vue&type=script&lang=js"
import style0 from "./instForm.vue?vue&type=style&index=0&id=585f8e73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f8e73",
  null
  
)

export default component.exports